import { _userLevel } from 'ecp/models/UsersModel'

const PopulationModel = {
  isDisabledPopulationLimitInput: (userLevel: _userLevel) => (userLevel === 'auditor'),

  showPopulationSubmtiButton: (userLevel: _userLevel) => (userLevel !== 'auditor')
}

export default PopulationModel
